import { useState, useEffect } from "react";

async function logout() {
  await fetch("https://einblau.ee/backend/api/logout.php", {
    credentials: "include",
  });
  localStorage.removeItem("adminToken");
  window.location.href = "/";
}

export default function AdminPanel() {
    const [loading, setLoading] = useState(true);
    const [authorized, setAuthorized] = useState(false);
    const [file, setFile] = useState(null);

    const [message, setMessage] = useState("");

    
    useEffect(() => {
        async function check() {
            const res = await fetch("https://einblau.ee/backend/api/check-auth.php", {
                credentials:"include",
            });

            const data = await res.json();
            setAuthorized(data.authorized);
            setLoading(false);
        }

        check()
    }, []);

    if (loading) return <p>Loading...</p>;
    if (!authorized) return <p>Not authorized{window.location.href ="/"}</p> 

    const handleFileChange = (e) => {
        setFile(e.target.files[0]);
    };

  

    const handleSubmit = async (e) => {
        e.preventDefault();
        const formData =  new FormData();
        formData.append("csvFile", file);
        try {
            const res = await fetch("https://einblau.ee/backend/api/upload.php", {
                method:"POST",
                body: formData,
                credentials:"include"
            });

            const result = await res.text();
            setMessage(result);

        } catch (err) {
            console.error(err);
        }
    };

    return (
        <div>
            <h1>Admin Panel</h1>
            <button onClick={logout}>logout</button>
            <form onSubmit={handleSubmit}>
                Vali uus hinnakiri
                <input type="file" accept=".csv" onChange={handleFileChange} />
                <input type="submit" value="Upload Image" name="submit"></input>
            </form>
            <p>{message}</p>
        </div>
    ) ;
}